<template>
  <b-modal
    id="create-subscription-plan-modal"
    centered
    hide-footer
    title="Create Subscription Plan"
  >

    <b-form-group label="Plan Name">
      <b-form-input v-model="name" />
    </b-form-group>

    <b-form-group label="Price">
      <b-form-input type="number" v-model="price" />
    </b-form-group>

    <b-form-group label="Lead / Month">
      <b-form-input type="number" v-model="max_leads_per_month" />
    </b-form-group>

    <b-form-group label="Maximum States">
      <b-form-input type="number" v-model="max_states" />
    </b-form-group>



    <div class="text-right">
      <b-button variant="primary" @click="submit">
        Create
      </b-button>
    </div>

  </b-modal>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      name: "",
      price: 0,
      max_leads_per_month: 0,
      max_states: 0,
    };
  },

  methods: {
    ...mapActions("appData", ["createSubscriptionPlan"]),

    async submit() {
      await this.createSubscriptionPlan({
        name: this.name,
        price: this.price,
        max_leads_per_month: this.max_leads_per_month,
        max_states: this.max_states,
      });

      this.$bvModal.hide("create-subscription-plan-modal");
      this.$emit("modalClosed");
    },
  },
};
</script>